export function sendTrackingInfo(eventCategory = 'Panel', eventAction = '', eventLabel = '') {
  const data = {
    event: 'trackEvent',
    eventCategory,
    eventAction,
    eventLabel
  };

  if (window.dataLayer) {
    window.dataLayer.push(data);
  }
}

export function sendCustomTrackingInfo(objectDataLayers = '') {
  if (objectDataLayers && window.dataLayer) {
    window.dataLayer.push(objectDataLayers);
  }
}
